import { DatePipe } from '@angular/common';

export const formatDate = (date: Date, pipe: DatePipe): string =>
  pipe.transform(date, "dd 'de' MMM YYYY")?.replace(/de (\w)(\w{2}\.)/, (_, a, b) => `de ${a.toUpperCase()}${b}`) as string;
